export const WeddingLoveIcon = () => {
  return (
    <svg
      width="17"
      height="18"
      viewBox="0 0 17 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.4969 5.09019L7.19256 6.06952L6.48796 5.32436C5.78785 4.58394 4.9531 3.97922 4.13809 3.69385C3.33676 3.41326 2.60399 3.45235 1.98305 3.90296C0.574195 4.92536 0.0954037 7.08001 1.23162 9.67211C2.32755 12.1723 4.90681 14.9573 9.34003 17.0582C12.0541 14.3022 14.3252 10.7075 15.2417 7.56078C15.7169 5.92936 15.8104 4.47907 15.4749 3.34491C15.15 2.24646 14.4103 1.39442 13.0728 0.927986C11.6695 0.43857 10.5215 0.802924 9.59088 1.61288C8.63241 2.44705 7.91086 3.75811 7.4969 5.09019Z"
        stroke="#298677"
        strokeWidth="1.2"
      />
    </svg>
  );
};
